/**
 * Typography Authority
 * 
 * Authority: SYSTEM_UI_CONTRACT.md Section 4
 * Purpose: Single source of truth for ALL typography in the system
 * 
 * RULES:
 * - This is the ONLY file allowed to define text size, weight, spacing
 * - Pages and modules MUST import from here, NEVER define inline
 * - Enforcement: Gate 24 (blocks deployment if violated)
 */

export const Typography = {
    // Headings (DM Sans)
    h1: "text-2xl font-heading font-semibold",
    h2: "text-xl font-heading font-medium",
    h3: "text-lg font-heading font-medium",
    h4: "text-base font-heading font-medium",

    // Body Text (Inter)
    body: "text-base font-sans",
    bodySmall: "text-sm font-sans",
    bodyLarge: "text-lg font-sans",

    // UI Elements
    label: "text-sm font-sans font-medium", // noscan
    caption: "text-xs font-sans",
    button: "text-sm font-sans font-medium",

    // Special Cases
    sectionHeading: "text-sm font-sans font-semibold uppercase tracking-wide",
    cardTitle: "text-lg font-heading font-medium",
    cardSubtitle: "text-sm font-sans",
    cardMeta: "text-xs font-sans font-medium",
};
